import { gql } from 'apollo-angular';

export const companyBaseFragment = gql`
fragment companyBase on Company {
  _id
  fullName
  logo
  primaryPath
  slug
  accountType
  accountStatus
  customerSince
  metaTitle
  reportLink
  owner {
    _id
  }
  hasLeads
  hasRequests 
  sponsorLevel
}
`;
